export default function UnderConstructionPage() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center p-6 max-w-md">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Sitio en construcción</h1>
      </div>
    </div>
  );
}
